<template>
  <div>
    <BaseButton
      v-if="hasShowMore"
      class="show-more-button"
      theme="secondary"
      outline
      :loading="fetching"
      full-width
      @click="onShowMore"
    >
      <span class="show-more-button__icon icon-redo" />
      <span class="show-more-button__text">{{ $t('common.show_more_count', { count: showCount }) }}</span>
    </BaseButton>
  </div>
</template>

<script lang="ts" setup>
type Props = {
  fetching: boolean
  limit?: number
  offset?: number
  length?: number
  count?: number
}

type Emits = {
  (e: 'on-show-more', offset: number): void
}

const props = withDefaults(defineProps<Props>(), {
  limit: 0,
  offset: 0,
  length: 0,
  count: 0
})
const emits = defineEmits<Emits>()

const hasShowMore = computed(() => {
  return newOffset.value < props.count
})

const newOffset = computed(() => {
  return props.length > 0
    ? props.length
    : props.offset + props.limit
})

const showCount = computed(() => {
  const availableQuantity: number = props.count - newOffset.value

  if (availableQuantity < props.limit) {
    return availableQuantity
  }
  return props.limit
})

const onShowMore = () => {
  emits('on-show-more', newOffset.value)
}

watch(() => props.fetching, (newValue: boolean) => {
  if (!newValue) {
    const scrollYOnShowMore = window.scrollY

    nextTick(() => {
      window.scrollTo(0, scrollYOnShowMore)
    })
  }
})

</script>

<style lang="scss" scoped>
.show-more-button {
  @media only screen and (min-width: 1024px) {
    transition: background $transition-time;
    &:hover {
      background: #F8F8F8;
    }
  }
  &__icon {
    font-size: 1.8rem;
    color: $primary-color;
    margin-right: .8rem;
    vertical-align: text-bottom;
  }
  &__text {
    color: #000000;
  }
}
</style>
